// Input：原生 input + shadcn 默认样式 + tabular-nums 友好。
// 同文件附带 Field（label + error/hint 包装器）与 Textarea / Label re-export，
// 兼容 Phase 4 业务组件 `import { Field, Input, Textarea } from "@/components/ui/Input"`
// 的引用形式（避免每个表单文件都改 3 行 import）。

import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export { Label } from "./Label";
export { Textarea } from "./Textarea";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...rest }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-9 w-full rounded border border-[hsl(var(--input))] bg-transparent px-3 py-1 text-sm text-[hsl(var(--foreground))] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[hsl(var(--muted-foreground))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...rest}
    />
  ),
);
Input.displayName = "Input";

// Field：label + control + error/hint 包装。react-hook-form 的字段错误信息通过
// error prop 传入；error 优先于 hint 展示。htmlFor 关联到子控件的 id（调用方
// 自行保证 id 一致）。
export function Field({
  label,
  htmlFor,
  error,
  hint,
  children,
  className,
}: {
  label?: ReactNode;
  htmlFor?: string;
  error?: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("space-y-1", className)}>
      {label ? (
        <label
          htmlFor={htmlFor}
          className="mb-1 block text-xs text-[hsl(var(--muted-foreground))]"
        >
          {label}
        </label>
      ) : null}
      {children}
      {error ? (
        <div className="text-xs" style={{ color: "hsl(var(--danger))" }}>
          {error}
        </div>
      ) : hint ? (
        <div className="text-xs text-[hsl(var(--muted-foreground))]">{hint}</div>
      ) : null}
    </div>
  );
}
